module.exports = __webpack_public_path__ + "d2816a47bcce81315c739d3e0ef76336.png";